import { wiaAccessTech, wiaAccessTechFullName } from "../types/index.const";

const wiaAccessTechOptions = wiaAccessTech.map((el, index) => ({
  label: wiaAccessTechFullName[index],
  value: el,
}));
export default wiaAccessTechOptions;
